import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    gap: 12px;
    padding: 12px 14px;
    margin-bottom: 8px;
    cursor: pointer;
    border-radius: 12px;
    background: ${(props) => (props.$active ? "#E8F1FF" : "transparent")};
    transition: background .15s;

    &:hover {
        background: ${(props) => (props.$active ? "#E8F1FF" : "#F3F7FF")};
    }
`;

export const AvatarWrap = styled.div`
    flex: 0 0 auto;
    align-self: flex-start;
`;

export const Avatar = styled.div`
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background: ${(props) => props.$color || "#2BC0AD"};
    color: #FFFFFF;
    font-weight: 700;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img { width: 100%; height: 100%; object-fit: cover; }
`;

export const Body = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Name = styled.span`
    flex: 1;
    min-width: 0;
    font-weight: 800;
    color: #2B3240;
    font-size: 0.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const TopRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

export const Time = styled.span`
    flex: 0 0 auto;
    color: #9AA4B2;
    font-size: 0.72rem;
    font-weight: 600;
`;

export const Preview = styled.div`
    margin-top: 3px;
    color: #6B7280;
    font-size: 0.78rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Members = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 6px;
    color: #9AA4B2;
    font-size: 0.74rem;

    svg { font-size: 0.85rem; }
`;

export const UnreadBadge = styled.span`
    flex: 0 0 auto;
    align-self: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border-radius: 10px;
    background: #2F80ED;
    color: #FFFFFF;
    font-size: 0.72rem;
    font-weight: 800;
    line-height: 20px;
    text-align: center;
`;
